angular.module('bmsApp.dashboard').factory('LiveStreamSvc', function (CRUDSvc, LIVE_STREAM) {
	return {
		index: function (params) {
			return CRUDSvc.get(LIVE_STREAM.INDEX, params);
		},
	}
}).constant('LIVE_STREAM', {
	INDEX: 'api/live-stream/index'
});



